<template>
 <div class="home_page">
  <heroArea></heroArea>
  <!-- <aboutArea></aboutArea>
  <counterArea></counterArea>
  <whatArea></whatArea>
  <beforeafterArea></beforeafterArea>
  <serviceArea></serviceArea>
  <testmonialArea></testmonialArea>
  <partnerArea></partnerArea>
  <ownerArea></ownerArea>
  <teamArea></teamArea> -->
 </div>
</template>

<script>
import heroArea from '@/components/home/heroArea.vue';
// import aboutArea from '@/components/home/aboutArea.vue';
// import counterArea from '@/components/home/counterArea.vue';
// import whatArea from '@/components/home/whatArea.vue';
// import beforeafterArea from '@/components/home/beforeafterArea.vue';
// import serviceArea from '@/components/home/serviceArea.vue';
// import testmonialArea from '@/components/home/testmonialArea.vue';
// import partnerArea from '@/components/home/partnerArea.vue';
// import ownerArea from '@/components/home/ownerArea.vue';
// import teamArea from '@/components/home/teamArea.vue';

export default {
   name:'Home',
   data(){
    return{
    }
   },
   components:{
       heroArea,
      //  aboutArea,
      //  counterArea,
      //  whatArea,
      //  beforeafterArea,
      //  serviceArea,
      //  testmonialArea,
      //  partnerArea,
      //  ownerArea,
      //  teamArea
   },
   methods:{},
    mounted(){
         document.body.classList.add('HomePage');
    },
    destroyed(){
      document.body.classList.remove('HomePage');
    }
}
</script>
